import { AxiosResponse } from 'axios';
import { ON_FARM_BILLING_API_ENDPOINTS } from '../constants/apiEndpoints';
import { appContextGet } from './httpCommon/appAxios.service';
import { ODataParams } from '../types/interfaces/apiParams.interfaces';
import { OnFarmAccountsBillingResponse, OnFarmBillingPreview } from '../types/interfaces/onFarmBillingOverride.interfaces';

export const getOnFarmBillingPreview = (accountId: number): Promise<AxiosResponse<OnFarmBillingPreview>> => {
  return appContextGet(`${ON_FARM_BILLING_API_ENDPOINTS.PREVIEW}${accountId}/preview`);
};

export const getOnFarmBilledAccountsOData = (
  params?: ODataParams,
): Promise<AxiosResponse<OnFarmAccountsBillingResponse>> => {
  return appContextGet(ON_FARM_BILLING_API_ENDPOINTS.ACCOUNTS_ODATA, params);
};
